import React from "react";

import { ErrorAlert } from "@/components/common/errors/ErrorAlert";

import { useCrudListContext } from "./CrudListContext";

export const CrudListError: React.FC = () => {
  const { entityNamings, error } = useCrudListContext();

  if (error) {
    return (
      <ErrorAlert
        title={`Error loading data for ${entityNamings.plural}`}
        error={error}
      />
    );
  }

  return null;
};
